import React, { useCallback, useContext, useMemo } from 'react'
import { DimensionsContext } from '../../utils/dimensions-context'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'
import { ButtonIcon } from '../Button/Button'
import { PortalType, SlotPortal } from '../Portal'

const DesktopMenu: React.FC = ({ children }) => {
  const {
    state: { headerHeight, minimized },
    update,
  } = useContext(DimensionsContext)

  const menuClasses = classNames({
    [styles.Menu]: true,
    [styles.SideMenuB]: true,
    [styles.MinimizedMenu]: minimized,
  })

  const dynStyle = useMemo<React.CSSProperties>(
    () => ({
      paddingTop: headerHeight,
    }),
    [headerHeight]
  )

  const toggleMinimized = useCallback(() => {
    update({ minimized: !minimized })
  }, [minimized, update])

  return (
    <div className={menuClasses} style={dynStyle}>
      <div className={styles.Content}>{children}</div>
      <SlotPortal name={PortalType.Burger}>
        <ButtonIcon
          onClick={toggleMinimized}
          additionalClassNames={[styles.IconMenu, styles.ShowMenu]}
          title={'Toggle Menu'}
        />
      </SlotPortal>
    </div>
  )
}

export default DesktopMenu
